// extracted by mini-css-extract-plugin
export var ratingButton = "p_bd";
export var ratingButtonMaxRating5 = "p_bg";
export var ratingButtonSelected = "p_bf";